<template>

  <div class="browser" onselectstart="return false">
    <div class="beijing">
      <div class="header">
        <!-- <div class="logo" @click="goToHomePage"></div> -->
        <div class="header-left">
          
          <div class="title d-md-inline mytitle" @click="goToHomePage"><img src="../assets/logo-64x64.png"  alt="Logo" class="logo1">云点击浏览器</div>
        </div>
<!--        <div class="col-md-3 title text-light">
            首页
        </div> -->
        <!-- <ul class="menu">
          <li v-for="item in menuItems" :key="item.id" @click="goToPage(item.id)">
            {{ item.title }}
          </li>
        </ul> -->
        <!-- <ul class="nav-list">
          <li class="nav-item" v-for="item in navItems" :key="item.id" @click="navigateToPage(item.link)"
            :style="{ color: item.hover ? 'white' : 'rgba(255, 255, 255, 0.5)' }" @mouseover="item.hover = true"
            @mouseleave="item.hover = false">
            {{ item.text }}
          </li>
        </ul> -->
      </div>
      <div class="content">
        <div class="part-a" style="margin-top: -50px;">
          <div class="image-container">
            <img src="../assets/logo-256x256.png" alt="Image" class="image" />
          </div>
          <div class="text-container">
            <div class="text-line text-opa">
              云点击浏览器
              <!-- <span class="version">版本：11.8.0</span> -->
            </div>
            <div class="text-line large-text">智能高效 &nbsp; 一键直达</div>
            <button class="download-button" @click="downloadFile">
              立即下载
            </button>
            <div class="platforms">适用于：win11/win10/win8.1/win+/win7/win XP</div>
          </div>
        </div>
        <!-- part-b -->
        <div class=" row"  style="margin-top: 100px;">

        <!-- left-block -->
          <div class="col-md-4 pt-5">
            <div class="text-block pt-3" >
              <div class="text-line large-text1" >您的第二台电脑，随心所用</div>
              <div class="text-line large-text2">
                释放硬盘空间，软件游戏随意下载安装，不担心配置，不惧病毒，任意使用。
              </div>
            </div>
            <!-- <ul class="list">
              <li class="list-item" 
              v-for="(item, index) in listItems" :key="index"
              @mouseover="changeImage(item.imagePath)"
              :class="{ 'active': item.active }"
              @click="selectListItem(1)">
                <img class="list-image" src="item.basePath" :alt="item.altText"  />
                <p class="list-text">{{ item.text }}</p >
              </li> -->
            <!-- <li class="list-item" @click="selectListItem(2)">
                <img src="https://ie.sogou.com/7.0/webkit/img/logo.png" alt="Image 2" class="list-image" />
                <div class="list-text">文档 2</div>
              </li>
              <li class="list-item" @click="selectListItem(3)">
                <img src="https://ie.sogou.com/7.0/webkit/img/logo.png" alt="Image 3" class="list-image" />
                <div class="list-text">文档 3</div>
              </li> -->
            <!-- </ul> -->
          </div>
          
          
          <!-- right-block -->
          <div class="col-md-8">
            <!-- <img src="https://browser.qq.com/static/docs-word.png" alt="Large Image" class="large-image" /> -->
            <!-- <img class="large-image" :src="selectedImage" alt="Large Image" /> -->
            <img class="large-image" style="width: 1100px;margin-left: 30px;" src="../assets/1176.png" alt="Large Image" />
          </div>
        </div>

        <div class="part-c">
          <div class="base">
            <div class="part-c-left">
              <img class="leftImg" style="margin-left: 10px;" src="../assets/1175.f2b5f482.png" alt="">
            </div>
            <div class="part-c-right">
              <div class="text-block">
                <div class="text-line large-text1">聚合AI工具，提升生产力</div>
                <div class="text-line large-text2">
                  集合了AI办公、Al设计、文案生成、音视频处理、等科技创新和便捷应用。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="footer-text">
          copyright2023 All Right Reserved 深圳市云网在线科技有限公司 版权所有  
          <a class="footer-texta" href="https://beian.miit.gov.cn/" target=_blank>
            粤ICP备19091375号
          </a>
        </div>
        <!-- <div class="footer-text">其他信息</div>
        <div class="footer-text">更多信息</div> -->
      </div>
    </div>
  </div>

</template>

<script>

export default {

  data() {
    return {
      menuItems: [
        { id: 1, title: "菜单项1" },
        { id: 2, title: "菜单项2" },
        { id: 3, title: "菜单项3" },
        { id: 4, title: "菜单项4" },
        { id: 5, title: "菜单项5" }
      ],
      navItems: [
        { id: 1, text: '功能', link: 'http://www.yunjiwan.com/', hover: false },
        { id: 2, text: '皮肤', link: 'http://www.yunjiwan.com/', hover: false },
        { id: 3, text: '扩展', link: 'http://www.yunjiwan.com/', hover: false },
        { id: 4, text: '帮助', link: 'http://www.yunjiwan.com/', hover: false },
        { id: 5, text: '用户反馈', link: 'http://www.yunjiwan.com/', hover: false },
      ],
      listItems: [
        { imagePath: 'https://browser.qq.com/static/docs-word.png', basePath: 'https://ie.sogou.com/7.0/webkit/img/logo.png', altText: 'Image 1', text: 'word', active: false },
        { imagePath: 'https://ie.sogou.com/7.0/webkit/img/logo.png', basePath: 'https://ie.sogou.com/7.0/webkit/img/logo.png', altText: 'Image 2', text: 'ppt', active: false },
        { imagePath: 'https://browser.qq.com/static/docs-word.png', basePath: 'https://ie.sogou.com/7.0/webkit/img/logo.png', altText: 'Image 3', text: 'pdf', active: false },
      ],
      selectedImage: '../assets/beijing.png',

    };
  },
  mounted() {
        // 禁用复制
        // this.$nextTick(() => {
        //     document.onselectstart = new Function("event.returnValue=false");
        // })
    },
  methods: {
    goToHomePage() {
      // 点击跳转到首页
    },
    goToPage(id) {
      // 根据id跳转到对应页面
    },
    downloadFile() {
      // 处理下载文件功能
      // 添加下载逻辑 
      // window.location.href = 'http://dl.yunjiwan.com/exe/YunGameBoxSetup.exe';
      // const downloadLink = 'http://ftp.yunjiyong.com/file/setup.exe' + "?"+Math.random();
      const downloadLink = 'http://d.yunjiwan.com/exe/Yundianji.exe' + "?"+Math.random();
      const folderPath = '/path/to/folder';
      const fileName = 'downloaded_file.zip';

      // 构建下载链接，包括文件名和文件路径
      const fullDownloadLink = `${downloadLink}?folder=${encodeURIComponent(folderPath)}&fileName=${encodeURIComponent(fileName)}`;

      // 在新窗口中打开下载链接
      window.open(fullDownloadLink);
    },
    selectListItem(itemId) {
      // 处理选择列表项的逻辑
    },

    changeImage(imagePath) {
      this.selectedImage = imagePath;
    },
  }
};
</script>

<style scoped>

.browser {
  /* min-width: 1300px; */
  background-color: #00aaff;
  width: 100%;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url('../assets/beijing1.png') no-repeat;
  background-size: contain;
  background-position: top center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

/* .beijing{
  width: 100%;
  background: url('../assets/beijing1.png') no-repeat;
  background-size: contain;
  background-position: top center;
} */

/* .beijing {
  width: 1200px;
} */

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  width: 1100px;
  margin: 0 auto;
  box-sizing: 999;

  .header-left {
    width: 900px;
  }

}

.logo {
  background-image: url("https://ie.sogou.com/7.0/webkit/img/logo.png");
  /* 设置logo的样式 */
}

.logo1 {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}

.title {
  /* 设置标题的样式 */
  color: #ffffff;
  font-size: 26px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu {
  display: flex;
  gap: 20px;
}

.menu li {
  /* 设置菜单项的样式 */
  color: #ffffff;
  cursor: pointer;
}

.nav-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin-right: -130px;
}

.nav-item {
  /* margin-right: 10px; */
  font-size: 18px;
  cursor: pointer;
  color: #fff;
  padding-left: 20px;
  transition: color 0.3s;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  overflow:hidden
}

.part-a {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 700px;
  width: 1100px;
  
  /* width: 100%; */
}

.image-container {
  /* 设置图片容器的样式 */
  width: 200px;
  width: 200px;
}

.image {
  /* 设置图片的样式 */
  /* height: auto; */
  margin-left: -500px;
}

.text-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: #ffffff;
  position: absolute;
  top: 200px;
  left: 500px;
  
}

.text-line {
  /* 设置文本行的样式 */
  padding: 10px 0;
  font-size: 28px;
}

.text-opa {
  opacity: 0.85;
}

.version {
  /* 设置版本号的样式 */
  font-size: 26px;
  margin-left: 10px;
}

.large-text {
  /* 设置大号文本的样式 */
  font-size: 66px;
  font-weight: 700;
  font-family: "阿里妈妈数黑体 Bold";
}

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "阿里妈妈数黑体 Bold";
  font-weight: 700;
  src: url("//at.alicdn.com/wf/webfont/1n30M2gDldRJ/IFFCMecN4DuC.woff2") format("woff2"),
    url("//at.alicdn.com/wf/webfont/1n30M2gDldRJ/E20APkuagPwc.woff") format("woff");
  font-display: swap;
}

.large-text1 {
  font-size: 52px;
}

.large-text2 {
  margin-top: 40px;
  font-size: 20px;
  width: 850px;
}

.download-button {
  /* 设置下载按钮的样式 */
  /* background-color: rgb(255, 255, 255, .3); */
  background-color: rgb(255, 255, 255, .1);
  border: #fff 1px solid;
  width: 300px;
  height: 80px;
  /* color: rgb(200, 200, 200); */
  color: #fff;
  padding: 10px 20px;
  border-radius: 55px;
  margin-top: 20px;
  cursor: pointer;
  transition: background-color 0.5s;
  font-size: 36px;
}

.download-button:hover {
  /* background-color: #888888; */
  background-color: rgb(255, 255, 255, .4);

}

.platforms {
  /* 设置适用平台的样式 */
  margin-top: 20px;
}

.part-b {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 700px;
  margin-top: 200px;
  /* width: 1300px; */
  /* background: url("../assets/组 1168.png") no-repeat; */
}

.left-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
}

.text-block {
  /* 设置文本块的样式 */
  width: 750px;
  padding-left: 40px;
}

.list {
  display: flex;
  gap: 10px;
  border-bottom: 1px solid #00ff00;
  padding-top: 20px;
  padding-bottom: 10px;
  margin-top: 20px;
  list-style: none;
}

.list-item {
  /* 设置列表项的样式 */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
}


.list-image {
  /* 设置列表项图片的样式 */
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
  /* 初始透明度为0 */
  opacity: 0;
}

.list-item.active .list-image {
  /* 设置平滑过渡效果 */
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}

.list-text {
  /* 设置列表项文本的样式 */
  margin-left: 10px;
}

.right-block {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;

}

.large-image {
  /* 设置大图的样式 */
  /* height: auto; */
  position: relative;
  left: -130px;
	width: 1100px;
}

.part-c {
  width: 1300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 700px;
  margin-top: 130px;
  padding-bottom: 200px;
}

.base {
  width: 100%;
  display: flex;
  height: 700px;
}

.part-c-left {
  width: 600px;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 200px;
}

.leftImg {
  width: 890px;
  height: 320px;
}

.part-c-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  margin-left: 50px;
}


.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.footer-text {
  /* 设置页脚文本的样式 */
  /* color: #ffffff; */
  color: #888888;
  margin: 0 10px;
  cursor: pointer;
}

.footer-texta {
  /* color: #888888; */
  color: rgb(0, 0, 0,.55);
  font-size: 12px;
}

</style>
